module.exports = __webpack_public_path__ + "static/media/83444.c32070e0.jpg";